import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import BlueNormalButton from '../customButtons/BlueNormalButton';
import PrimarySmallBlueButton from '../customButtons/PrimarySmallBlueButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function NoDataAvailableScreen({text, subText ,maxWidth, buttonName, topImage, redirectionLink,secondButtonName,secondRedirectionLink}) {
      const navigate = useNavigate();

      const handleNavigation =()=>{
        navigate(redirectionLink)
      }

      const handleSecondNavigation =()=>{
       window.open(secondRedirectionLink, "_blank"); // open in new tab
      }
  return (
 <Box
      sx={{
        maxWidth: maxWidth? maxWidth : 800,
        mx: "auto",

        p: 8,
        px: { xs: 2, sm: 7, md: 15 },
        textAlign: "center",
        borderRadius: 4,
        backgroundColor: "#fff",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        position: "relative",
      }}
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        sx={{
          width: "90px",
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "2px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Wishlist/Ellipse 9241.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Box
        position="absolute"
        bottom={0}
        right={0}
        sx={{
          width: "90px",
          borderBottomRightRadius: "15px",
          borderBottomLeftRadius: "2px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Wishlist/Ellipse 9240.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Grid container spacing={2}>

        
        <Grid item xs={12}>
          <Box
            sx={{
              width: 180,
              height: 180,
              mx: "auto",
             
            }}
          >
           {topImage}
          </Box>
        </Grid>

        {/* Title */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="22px"
            color="#343538"
            sx={{
              fontWeight: 600,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: "1.4",
            }}
          >
            {text}
          </Typography>
        </Grid>

        {/* Subtitle */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="16px"
            color="#3F424C"
            sx={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: 1.5,
            }}
          >
            {subText}
          </Typography>
        </Grid>

        {/* Button */}
        <Grid item xs={12} mt={1} container gap={2} justifyContent="center">
          {" "}
       <PrimarySmallBlueButton buttonTitle={buttonName} endIcon={<ArrowForwardIcon/>} onClick={handleNavigation}/>
              {secondButtonName && (
              <PrimarySmallBlueButton buttonTitle={secondButtonName} endIcon={<ArrowForwardIcon/>} onClick={handleSecondNavigation}/>

              )}

        </Grid>
      </Grid>
    </Box>
  )
}
